'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var select = require('./select-6c9d108c.js');
var selectItem = require('./select-item-7fd13c43.js');

var PickerContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  margin-top: 30px;\n"], ["\n  margin-top: 30px;\n"])));
var GeneralSelect = styled__default(select.Select)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  margin-top: 30px;\n  font: 14px/22px ", ";\n  color: ", ";\n"], ["\n  margin-top: 30px;\n  font: 14px/22px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var StyledSelectItem = styled__default(selectItem.SelectItem)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3;

exports.GeneralSelect = GeneralSelect;
exports.PickerContainer = PickerContainer;
exports.StyledSelectItem = StyledSelectItem;
